import { type SvgIconProps, SvgIcon as BaseSvgIcon } from '@shared/components';

// The icon here is based on tabler icons
// https://tabler.io/icons
// We use tabler icons here since it's aligned with @mantine/tiptap editor

export function SvgIcon(props: SvgIconProps) {
  return (
    <BaseSvgIcon
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      sx={{
        strokeWidth: '1.5',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        fill: 'none',
        width: '0.6em',
      }}
    />
  );
}

export function BoldIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M7 5h6a3.5 3.5 0 0 1 0 7h-6z' />
      <path d='M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7' />
    </SvgIcon>
  );
}

export function ItalicIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M11 5l6 0' />
      <path d='M7 19l6 0' />
      <path d='M14 5l-4 14' />
    </SvgIcon>
  );
}

export function UnderlineIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M7 5v5a5 5 0 0 0 10 0v-5' />
      <path d='M5 19h14' />
    </SvgIcon>
  );
}

export function StrikethroughIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M5 12l14 0' />
      <path d='M16 6.5a4 2 0 0 0 -4 -1.5h-1a3.5 3.5 0 0 0 0 7h2a3.5 3.5 0 0 1 0 7h-1.5a4 2 0 0 1 -4 -1.5' />
    </SvgIcon>
  );
}

export function ClearFormattingIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M17 15l4 4m0 -4l-4 4' />
      <path d='M7 6v-1h11v1' />
      <path d='M7 19l4 0' />
      <path d='M13 5l-4 14' />
    </SvgIcon>
  );
}

export function H1Icon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M19 18v-8l-2 2' />
      <path d='M4 6v12' />
      <path d='M12 6v12' />
      <path d='M11 18h2' />
      <path d='M3 18h2' />
      <path d='M4 12h8' />
      <path d='M3 6h2' />
      <path d='M11 6h2' />
    </SvgIcon>
  );
}

export function H2Icon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M17 12a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0' />
      <path d='M4 6v12' />
      <path d='M12 6v12' />
      <path d='M11 18h2' />
      <path d='M3 18h2' />
      <path d='M4 12h8' />
      <path d='M3 6h2' />
      <path d='M11 6h2' />
    </SvgIcon>
  );
}

export function H3Icon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M19 14a2 2 0 1 0 -2 -2' />
      <path d='M17 16a2 2 0 1 0 2 -2' />
      <path d='M4 6v12' />
      <path d='M12 6v12' />
      <path d='M11 18h2' />
      <path d='M3 18h2' />
      <path d='M4 12h8' />
      <path d='M3 6h2' />
      <path d='M11 6h2' />
    </SvgIcon>
  );
}

export function H4Icon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M20 18v-8l-4 6h5' />
      <path d='M4 6v12' />
      <path d='M12 6v12' />
      <path d='M11 18h2' />
      <path d='M3 18h2' />
      <path d='M4 12h8' />
      <path d='M3 6h2' />
      <path d='M11 6h2' />
    </SvgIcon>
  );
}

export function H5Icon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M17 18h2a2 2 0 1 0 0 -4h-2v-4h4' />
      <path d='M4 6v12' />
      <path d='M12 6v12' />
      <path d='M11 18h2' />
      <path d='M3 18h2' />
      <path d='M4 12h8' />
      <path d='M3 6h2' />
      <path d='M11 6h2' />
    </SvgIcon>
  );
}

export function H6Icon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M19 14a2 2 0 1 0 0 4a2 2 0 0 0 0 -4z' />
      <path d='M21 12a2 2 0 1 0 -4 0v4' />
      <path d='M4 6v12' />
      <path d='M12 6v12' />
      <path d='M11 18h2' />
      <path d='M3 18h2' />
      <path d='M4 12h8' />
      <path d='M3 6h2' />
      <path d='M11 6h2' />
    </SvgIcon>
  );
}

export function BulletListIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M9 6l11 0' />
      <path d='M9 12l11 0' />
      <path d='M9 18l11 0' />
      <path d='M5 6l0 .01' />
      <path d='M5 12l0 .01' />
      <path d='M5 18l0 .01' />
    </SvgIcon>
  );
}

export function NumberedListIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M11 6h9' />
      <path d='M11 12h9' />
      <path d='M12 18h8' />
      <path d='M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4' />
      <path d='M6 10v-6l-2 2' />
    </SvgIcon>
  );
}

export function AlignLeftIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M4 6l16 0' />
      <path d='M4 12l10 0' />
      <path d='M4 18l14 0' />
    </SvgIcon>
  );
}

export function AlignRightIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M4 6l16 0' />
      <path d='M10 12l10 0' />
      <path d='M6 18l14 0' />
    </SvgIcon>
  );
}

export function AlignCenterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M4 6l16 0' />
      <path d='M8 12l8 0' />
      <path d='M6 18l12 0' />
    </SvgIcon>
  );
}

export function SubscriptIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M5 7l8 10m-8 0l8 -10' />
      <path d='M21 20h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2' />
    </SvgIcon>
  );
}

export function SuperscriptIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M5 7l8 10m-8 0l8 -10' />
      <path d='M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2' />
    </SvgIcon>
  );
}

export function ArrowBackUpIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M9 14l-4 -4l4 -4' />
      <path d='M5 10h11a4 4 0 1 1 0 8h-1' />
    </SvgIcon>
  );
}

export function ArrowForwardUpIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M15 14l4 -4l-4 -4' />
      <path d='M19 10h-11a4 4 0 1 0 0 8h1' />
    </SvgIcon>
  );
}

export function PhotoIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M15 8h.01' />
      <path d='M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z' />
      <path d='M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5' />
      <path d='M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3' />
    </SvgIcon>
  );
}

export function TableIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z' />
      <path d='M3 10h18' />
      <path d='M10 3v18' />
    </SvgIcon>
  );
}

export function LatexIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M19 5h-7l-4 14l-3 -6h-2' />
      <path d='M14 13l6 6' />
      <path d='M14 19l6 -6' />
    </SvgIcon>
  );
}
